import { useDroppable } from '@dnd-kit/core';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface DroppableColumnProps {
  stage: { id: string; label: string; color: string };
  children: React.ReactNode;
  minHeight?: number;
}

export function DroppableColumn({ stage, children, minHeight }: DroppableColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: stage.id,
  });

  return (
    <Card 
      ref={setNodeRef} 
      className={cn(
        'p-4 flex-1 min-w-[300px] transition-all duration-300',
        isOver && 'bg-muted ring-2 ring-primary'
      )}
      style={{ minHeight: minHeight ? `${minHeight}px` : '400px' }}
    >
      {children}
    </Card>
  );
}
